import Service from '../Service';
import { addFingerprintToRequest } from './utils';
import Request from '../Request';
import { ResponseErrorBody } from '../../types';

export async function remove(deviceId: string) {
  const request = await addFingerprintToRequest(
    new Request<{}>(`/api/auth/devices/${deviceId}`).setMethod('DELETE')
  );
  const service = new Service<any, ResponseErrorBody>(request);
  return await service.send();
}
